export const Options = {
    body: {
        name: [],
        info: [],
        image: [],
        value: []
    }
};
